<template>
    <div class="page bg-blue relative desktop-footer min-h-screen">
        <div class="bg-head-coin sm:block"></div>
        <div class="page-content sm:px-8 min-h-screen flex flex-col pb-5">
            <TopbarBackLang routeBack="/"></TopbarBackLang>
            <TobbarLangDesktop :modalController="modalController"></TobbarLangDesktop>
            <MenuDesktop activeMenu="home"></MenuDesktop>
            <div class="sm:bg-white sm:px-5 sm:py-6 mt-4 rounded-25 flex flex-col flex-1 relative">
                <div class="bg-white rounded-25 mx-3 pt-10 pb-16 h-full flex-1">
                    <div class="text-center text-24 text-tc-blue-2">{{ lbl.forgetpassword.changepassword }}</div>
                    <div class="text-center text-20 text-tc-gray-3 pt-10px pb-4">{{ lbl.forgetpassword.please_input_phone }}</div>
                    <div class="flex justify-center">
                        <div class="sm:px-0 px-5 sm:w-329px w-full">
                            <InputRadio
                                v-model:inputValue="formData.password_type"
                                :inputLbl="lbl.register.form.passwordFormat"
                                :itemList="formatPasswordList"
                                :errorInfo="errorInfo[6]"
                                :isFirstSave="isFirstSave"
                                :isShowErrorLbl="true"
                                :isShowStar="true"
                            ></InputRadio>
                            <div v-if="formData.password_type === 'pin'">
                                <PinFormat
                                    :form="formData"
                                    :errorInfo="errorPin"
                                    :isFirstSave="isFirstSave"
                                    customStyle="grid grid-cols-1"
                                    pinStyle1="px-5px"
                                    pinStyle2="px-5px pt-4"
                                />
                            </div>
                            <div v-else>
                                <PasswordFormat
                                    :form="formData"
                                    :errorInfo="errorPassword"
                                    :isFirstSave="isFirstSave"
                                    customStyle="grid grid-cols-1"
                                    passwordStyle1="px-5px"
                                    passwordStyle2="px-5px pt-4"
                                />
                            </div>
                            <div class="max-w-300px w-full text-20 mx-auto mt-5">
                                <BlueBtn @click="onSubmit()">{{lbl.register.confirm}}</BlueBtn>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="absolute bottom-10 s:bottom-7 left-0 right-0 sm:hidden">
                    <div class="text-center">
                        <img class="w-44 m-auto pt-3" src="@/assets/poer-tip.png" />
                    </div>
                </div>
            </div>
        </div>
        <BottomBar></BottomBar>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import TopbarBackLang from '@/components/Layout/TopBar/TopbarBackLang.vue';
import TobbarLangDesktop from '@/components/Layout/TopBar/TobbarLangDesktop.vue';
import MenuDesktop from '@/components/Layout/MenuDesktop/MenuDesktop.vue';
import BottomBar from '@/components/Layout/BottomBar/BottomBar.vue';
import InputRadio from "@/components/Input/label/InputRadioInline.vue";
import BlueBtn from "@/components/Button/BlueBtn.vue";
import PasswordFormat from "@/module/Register/component/PasswordFormat/Password.vue"
import PinFormat from "@/module/Register/component/PasswordFormat/Pin.vue"
//mixin
import { FormHelper } from "@/helper/FormHelper.js"; //from helper
import { RegisterModel,ValidateForm } from "@/core/Account/model/RegisterModel";

export default {
    name: "Default",
    mixins: [LocaleMixin],
    props:{
        modalController: Object
    },
    components: {
        TopbarBackLang,
        TobbarLangDesktop,
        MenuDesktop,
        BottomBar,
        InputRadio,
        BlueBtn,
        PinFormat,
        PasswordFormat
    },
    data: function() {
        return {
           formData: {
                password_type: 'password',
                password: '',
                confirmpassword: '',
                pin: '',
                confirmpin: ''
            },
            errorInfo: [],
            errorPassword: [],
            errorPin: [],
            isFirstSave: true,
            genderList: new RegisterModel().setGenderList(),
            nationalityList: new RegisterModel().setNationalityList(),
            formatPasswordList: new RegisterModel().setFormatPassword(),
        };
    },
    created: function() {
        this.errorInfo = FormHelper.genErrorInfo(7);
        this.errorPassword = FormHelper.genErrorInfo(2);
        this.errorPin = FormHelper.genErrorInfo(2);
    },
    methods: {
        onSubmit: function(){
            this.isFirstSave = false;
            let validate = this.validateRegisterForm();
            //console.log("password_type", this.formData.password_type)
            if(validate.pass){
                this.$emit('onclick', this.formData);
            }else{
                this.modalController.alertModal.setMsg(validate.msg).show()
            }
        },
        validateRegisterForm: function(){
            this.isFirstSave = false;
            let validate = new ValidateForm();
            const validateInput = validate.validateForm(this.errorInfo);
            const validatePasswordType = validate.validatePasswordType(this.formData , this.errorPin , this.errorPassword);
            const validateMatchPassword = validate.validateMatchPassword(this.formData);
            const checkFormatPassword = new ValidateForm().checkFormatPassword(this.formData);
            if(!validateInput){
                return { pass: false, msg: this.lbl.home.input_field }
            }else if(!validatePasswordType){
                return { pass: false, msg: this.lbl.home.password_format }
            }else if(!validateMatchPassword){
                return { pass: false, msg: this.lbl.home.password_not_match }
            }else if(!checkFormatPassword){
                return { pass: false, msg: this.lbl.register.form.passwordFormatText }
            } else{
                return { pass: true, msg: ''}
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.logo-powerby {
    width: 166px;
}
</style>
